import { toast } from "common";
import { Accessor, createMemo, createSignal, Setter } from "solid-js";
import { reportResults as api } from 'st-app/api'

export class ReportResultsContext {
    processQueueGu: Accessor<string>;

    loading: Accessor<boolean>; setLoading: Setter<boolean>;
    data: Accessor<any[]>; setData: Setter<any[]>;
    scrollFields: Accessor<string[]>; setScrollFields: Setter<string[]>;
    

    constructor(processQueueGu: Accessor<string>) {
        this.processQueueGu = processQueueGu;
        [this.loading, this.setLoading] = createSignal(false);
        [this.data, this.setData] = createSignal<any[]>([]);
        [this.scrollFields, this.setScrollFields] = createSignal<string[]>([]);
    }

    async load() {
        this.setLoading(true);
        try {
            const results = await api.LoadReportOutput(this.processQueueGu());
            this.setData(results.dataRoot.data);

            try {
                const scrollFields = await api.GetScrollFieldsForJob(this.processQueueGu());
                this.setScrollFields(scrollFields);
            } catch (e) {
                console.error('Error parsing report results scroll fields:', e);
            }
        } catch (e) {
            toast.notify('error', 'Error loading report results');
            console.error('Error loading report results:', e);
        }
        this.setLoading(false);
    }
}
